// extracted by mini-css-extract-plugin
export var container = "_do-0";
export var popoverContent = "_do-1";
export var tosLink = "_do-2";